/** @jsxImportSource @emotion/react */
import AdminMainPanel from '../Layouts/AdminMainPanel';
import NavBar from '../Layouts/NavBar';

const Sites = () => {
    return (
        <AdminMainPanel>
            <NavBar />
            <div className="admin-main-content">Sites</div>
        </AdminMainPanel>
    );
};

export default Sites;
